import liskovLogo from "../images/logos/Liskov_logo.svg";

function ContactPage() {
	return (
		<section class="contact-page" id="contact-section">
			<div className="one-line">Get in touch!</div>
			<div>
				<p className="course-warning">
					These courses are not easy. We take this seriously - and we also
					understand it's not a small amount of money to part with. It's an
					investment in your future and a huge responsibility for us. It's on us
					to see you through.
				</p>
				<p className="course-warning">
					It's also important that we have a chat to you about whether this
					course is right for you. We are open to people from all walks of life
					- and part of our mission is to bring more diversity to the tech space
					- but it's also important that all students have the full story of
					what they are getting in to, and are ready for the course.
				</p>
				<p className="phone-call">
					If your key interest is learning to code, call MATT on:
					<div className="phone-number">
						<a href="tel:+61411867667">+61 411 867 667</a>
					</div>
				</p>
				<p className="phone-call">
					If your key interest is learning UX design, call MICHAEL on:
					<div className="phone-number">
						<a href="tel:+61414133958">+61 414 133 958</a>
					</div>
				</p>
				<p className="course-warning">Or drop us a line here:</p>
			</div>
			<div class="email-info">
				<form
					class="form-container"
					name="contact"
					id="contact"
					method="POST"
					data-netlify="true"
					action="/success-page"
				>
					<h3>..get in touch</h3>
					<input type="hidden" name="form-name" value="contact" />
					<label for="name">*Name:</label>
					<input
						id="name"
						placeholder="Name"
						name="name"
						type="text"
						tabindex="0"
						required
						autofocus
					/>

					<label for="email">*Email address:</label>
					<input
						id="email"
						placeholder="Email address"
						name="email"
						type="email"
						tabindex="0"
						required
					/>

					<label for="phone">Phone number:</label>
					<input
						id="phone"
						placeholder="Phone number"
						name="phone number"
						type="tel"
						tabindex="0"
					/>

					<label for="message">Message:</label>
					<textarea
						id="message"
						placeholder="Type your message here.."
						name="message"
						tabindex="0"
					></textarea>

					<button
						name="submit"
						type="submit"
						id="contact-submit"
						data-submit="...Sending"
					>
						submit..
					</button>
				</form>
				{/* <div class="liskov-logo">
                    L<span class='semi-colon'>;</span>
                </div> */}
				<div class="liskov-logo-contact">
					<img id="liskov-logo-contact" src={liskovLogo} alt="liskov logo" />
				</div>
			</div>
		</section>
	);
}

export default ContactPage;
